export default "__VITE_ASSET__FSUgfdWm__"